import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';

import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

export function KnockoutGamesCount() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Количество партий</FormLabel>
      <FormInput>
        <Controller
          name="knockOutSettings.gamesPerRound"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input
              invisible
              type="number"
              rightLabel="на раунд"
              value={value.toString()}
              onChange={onChange}
              min="1"
              max="9"
              disabled={disabled}
            />
          )}
        />
        <Controller
          name="knockOutSettings.gamesPerFinalRound"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Input
              invisible
              type="number"
              rightLabel="на финал"
              value={value.toString()}
              onChange={onChange}
              min="1"
              max="9"
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
